import React, { cloneElement } from 'react';

import Logo from 'components/template/Logo';

import { APP_NAME } from 'constants/app.constant';

// backgroundImage: `url('/img/others/auth-side-bg.jpg')`,

const Side = ({ children, content, ...rest }) => {
	return (
		<div className="grid lg:grid-cols-3 h-full">
			<div
				className="bg-no-repeat bg-cover py-6 px-16 flex-col justify-between hidden lg:flex"
				style={{
					backgroundColor: '#101111',
				}}>
				<Logo mode="dark" logoWidth="180px" />
				<div>
					<div className="mb-6 flex items-center gap-4">
						<div className="text-white">
							<div className="font-semibold text-base">
								Seguridad e Innovación
							</div>
							<span className="opacity-80">
								ITEA Technology, Tampico, México.
							</span>
						</div>
					</div>
					<p className="text-base text-white opacity-80">
						La seguridad y eficiencia de las operaciones están aseguradas por
						medio de nuestra plataforma de gestión de contratistas, lo cual
						resulta en una disminución de los riesgos relacionados con la
						subcontratación.
					</p>
				</div>
				<span className="text-white">
					Copyright &copy; {`${new Date().getFullYear()}`}{' '}
					<span className="font-semibold">{`${APP_NAME}`}</span>{' '}
				</span>
			</div>
			<div className="col-span-2 flex flex-col justify-center items-center bg-white dark:bg-gray-800">
				<div className="xl:min-w-[450px] sm:min-w-[100%] px-6">
					<div className="mb-8">{content}</div>
					{children ? cloneElement(children, { ...rest }) : null}
				</div>
			</div>
		</div>
	);
};

export default Side;
